'use strict';

(function () {
    'use strict';

    settingsService.$inject = ['$http', 'appConfig'];
    angular.module('app.services').factory('settingsService', settingsService);

    function settingsService($http, appConfig) {
        'ngInject';

        var service = {
            getValue: getValue
        };

        return service;

        ////////////////
        function getValue(key) {
            var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var config = { params: { _key: 'eq.' + key }, cache: true };

            return $http.get(appConfig.apiUrl + '/settings', config).then(function (rsp) {
                return _.get(rsp, 'data.0._value', defaultValue);
            });
        }
    }
})();